import { FaPlus } from 'react-icons/fa6';
import { twMerge } from 'tailwind-merge';

import { Button, ButtonProps } from '@/components/Button';

export type CloseProps = ButtonProps;

export function Close({ className, ...props }: CloseProps) {
  return (
    <Button
      variant="outline"
      className={twMerge(
        'absolute top-8 left-3 lg:left-20',
        'rounded-full bg-white',
        className,
      )}
      {...props}
    >
      <FaPlus className="size-5 rotate-45" />
    </Button>
  );
}
